class SalonDTO {
  constructor(salon) {
    this.sensorIdsToDetach = salon.sensorIdsToDetach;
    this.name = salon.name;
    this.phone = salon.phone;
    this.supervisor = salon.supervisor;
    this.address = salon.address;
    this.groups = salon.groups || [];
    this.sensors = salon.sensors || [];
    this.sid = salon.sid;
    this.postalCode = salon.postalCode;
    this.city = salon.city;
    this.longitude = this.validateGeo(salon.longitude);
    this.latitude = this.validateGeo(salon.latitude);
    if (salon.sensors !== undefined) {
      this.sensors = salon.sensors;
    }
    if (salon.sensorIdsToDetach !== null) {
      salon.sensorIdsToDetach.forEach((val) => {
        const index = this.sensors.findIndex(sensor => sensor.id === val);
        this.sensors.splice(index, 1);
      });
    }
    if (salon.id > 0) {
      this.id = salon.id;
    }
  }

  validateGeo(value) {
    let normalized = 0;
    if (value !== undefined) {
      normalized = String(value).replace(',', '.');
    }
    return normalized;
  }
}

export default SalonDTO;
